import { graphql, useStaticQuery } from "gatsby"

export default function useWineryData() {
  const data = useStaticQuery(graphql`
    query getWineryData {
      allMarkdownRemark(
        filter: { fileAbsolutePath: {regex: "/(wine)/"  } },
        ) {
        edges {
          node {
            id
            frontmatter {
              title
              slug
              region
              coordinates {
                lat
                long
              }
            }
          }
        }
      }
    }
  `)
  return data.allMarkdownRemark.edges
}